export default __webpack_public_path__ + "static/media/ysd-koshiki.210dd005.jpg";